<template>
  <v-dialog v-model="show" width="550" @click:outside="onClickOutside">
    <v-card>
      <div class="header-icon-wrapper">
        <v-icon color="blue darken-2">mdi-alert</v-icon>
      </div>
      <div class="wrapper-title">
        <h3>{{ $t("provisionsNotMet") }}</h3>
      </div>
      <v-list shaped :disabled="true">
        <v-list-item-group v-model="metProvisions" multiple>
          <template v-for="(item, i) in provisions">
            <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

            <v-list-item
              v-else
              :key="`item-${i}`"
              :value="item"
            >
              <template v-slot:default="{ active }">
                <v-list-item-title>
                  {{ $t(item.key) }} {{ item.screenshotCount }}/{{ item.min }}
                </v-list-item-title>
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                  ></v-checkbox>
                </v-list-item-action>
              </template>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
      <div class="wrapper-action">
        <v-row>
          <v-col>
            <v-btn large color="primary" @click="onPrimary"
              >{{ $t("ok") }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ProvisionsNotMetDialog from "./mixin/ProvisionsNotMetDialog";

export default {
  mixins: [ProvisionsNotMetDialog]
};
</script>

<style lang="scss" scoped>
$primaryColor: #3fa2f7;
.header-icon-wrapper {
  text-align: center;
  padding-top: 20px;
  .v-icon {
    font-size: 5rem;
  }
}
.wrapper-title {
  text-align: center;
  margin-top: 5%;
  color: $primaryColor;
}
.wrapper-action {
  text-align: center;
  padding: 20px;
  .v-btn {
    width: 90%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ProvisionsNotMetDialog.vue